import React from 'react';
import moment from 'jalali-moment'

/*
    - ihoDesignSystem
*/
import { Box, Grid, Typography } from '@iho-design-system/Loader';

const ReserveList = ({ reservesResult, selectedService, searchInputSearchKey, selectReserveProps }) => {

    /*
        - defaultData
    */
    const [filteredReserveResult, setFilterReservedResult] = React.useState([]);
    let filteredReserveResultHelper = [];

    /*
        - filteredReserveResultHelper
    */
    React.useEffect(() => {
        if (reservesResult !== 'unauthorized' && reservesResult !== 'empty' && selectedService !== 'awaiting' && selectedService !== 'pending') {
            reservesResult.forEach((obj) => {
                if ((obj.reserveId !== undefined && obj.reserveId.toString().indexOf(searchInputSearchKey) > -1) || (obj.nuRequest !== undefined && obj.nuRequest.toString().indexOf(searchInputSearchKey) > -1)) {
                    filteredReserveResultHelper.push(obj);
                }
            });
            setFilterReservedResult(filteredReserveResultHelper);
        }
    }, [reservesResult, searchInputSearchKey]);

    return (

        <React.Fragment>

            {selectedService !== 'awaiting' && selectedService !== 'pending' &&
                <Box
                    className={`w-100 my-lg mb-0 border-solid-top border-medium`}
                    ms={{
                        '@keyframes reserveAnimation': {
                            'from': {
                                opacity: '0',
                            },
                            'to': {
                                opacity: '1',
                            }
                        }
                    }}>
                    <Typography
                        className={`py-md`}
                        component='h5'>
                        سوابق رزرو
                    </Typography>
                    {(filteredReserveResult.length !== 0 && selectedService !== 'awaiting' && selectedService !== 'pending') &&
                        <Box
                            className={`w-100`}
                            ms={{
                                minHeight: '136px',
                                maxHeight: '136px',
                                overflowY: 'auto',
                                '&::-webkit-scrollbar': {
                                    width: '4px',
                                    opacity: '0'
                                },
                                '&::-webkit-scrollbar-thumb': {
                                    backgroundColor: 'var(--blue-medium)',
                                    borderRadius: 'var(--sizing-md)'
                                }
                            }}>
                            {filteredReserveResult.map((obj, index) => {
                                return (
                                    <Box
                                        key={index}
                                        onClick={() => selectReserveProps(obj)}
                                        className={`w-100 my-xs mt-0 border-solid border-medium rounded-sm pointer position-relative`}
                                        ms={{
                                            opacity: '0',
                                            animation: 'reserveAnimation 0.5s linear',
                                            animationDelay: 0.75 + +index / 10 + 's',
                                            animationFillMode: 'forwards',
                                        }}>
                                        <Grid>
                                            <Grid.Wrapper>
                                                <Grid.Item
                                                    className={`align-self-center`}
                                                    size='col-4'>
                                                    <Typography>
                                                        {obj.hotelName.length <= 15 ? obj.hotelName : (obj.hotelName.substr(0, 15) + '...')}
                                                    </Typography>
                                                </Grid.Item>
                                                <Grid.Item
                                                    size='col-4'>
                                                    <Typography
                                                        className={`w-100 px-sm text-primary text-center rounded-sm`}
                                                        ms={{
                                                            backgroundColor: 'var(--blue-ultra-light)'
                                                        }}>
                                                        {moment(obj.arrivalDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD').split('/')[2].replace('0', '')} {moment(obj.arrivalDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MMMM/DD').split('/')[1].replace('0', '')}
                                                        <br />
                                                        {moment(obj.exitDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MM/DD').split('/')[2].replace('0', '')} {moment(obj.exitDate.split('T')[0], 'YYYY/MM/DD').locale('fa').format('YYYY/MMMM/DD').split('/')[1].replace('0', '')}
                                                    </Typography>
                                                </Grid.Item>
                                                <Grid.Item
                                                    size='col-4'
                                                    className={`align-self-center`}>
                                                    <Typography
                                                        className={`d-block`}>
                                                        کد رزرو
                                                    </Typography>
                                                    <Typography
                                                        className={`mx-xs ml-0 text-primary`}>
                                                        {obj.reserveId}
                                                        {obj.nuRequest}
                                                    </Typography>
                                                </Grid.Item>
                                            </Grid.Wrapper>
                                        </Grid>
                                    </Box>
                                )
                            })}
                        </Box>
                    }
                    {filteredReserveResult.length === 0 &&
                        <Box
                            className={`w-100 my-xs mt-0 border-solid border-medium rounded-sm pointer`}
                            ms={{
                                opacity: '0',
                                animation: 'reserveAnimation 0.5s linear',
                                animationDelay: '0.5s',
                                animationFillMode: 'forwards',
                            }}>
                            <Grid>
                                <Grid.Wrapper>
                                    <Grid.Item
                                        size='col-12'>
                                        <Typography
                                            className={`w-100 px-md rounded-sm`}
                                            ms={{
                                                lineHeight: '68px',
                                                color: 'var(--red-medium)',
                                                backgroundColor: 'var(--red-ultra-light)'
                                            }}>
                                            رزروی یافت نشد
                                        </Typography>
                                    </Grid.Item>
                                </Grid.Wrapper>
                            </Grid>
                        </Box>
                    }
                </Box>
            }

        </React.Fragment>

    );

}

export default ReserveList;